
import SignInButtons from '@/components/auth/Modal/SignIn/Buttons';

export default {
  name: 'AuthModalFooter',
  components: {
    SignInButtons,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
